import { Link, LinkProps } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { SearchResultsListItemProps, SearchResultsListItem } from './SearchResultsListItem';
import { useMagicSearchLinkProps } from '../MagicSearchContext';

type SearchResultsListItemLinkProps = LinkProps &
  SearchResultsListItemProps & {
    className?: string;
    isFocused?: boolean;
    disableHover?: boolean;
    type?: string;
  };

export const SearchResultsListItemLink: React.FC<SearchResultsListItemLinkProps> = ({
  className,
  children,
  title,
  icon,
  variant,
  description,
  isFocused,
  disableHover,
  type,
  ...other
}) => {
  const magicSearchLinkProps = useMagicSearchLinkProps();
  return (
    <Link
      className={twMerge(
        'block scroll-mb-4 scroll-mt-8',
        !disableHover && 'hover:bg-neutral-100',
        isFocused && 'bg-neutral-100',
        className,
      )}
      {...other}
      {...magicSearchLinkProps}
    >
      <SearchResultsListItem
        title={title}
        icon={icon}
        description={description}
        variant={variant}
        type={type}
      />
    </Link>
  );
};

SearchResultsListItemLink.displayName = 'SearchResultsListItemLink';
